import styled from "styled-components";
import Row from "react-bootstrap/Row";

export const Wrapper = styled(Row)`
  .active-button {
    min-height: ${({ $height }) => ($height ? $height : "50px")};
    font-size: ${({ $fontSize }) =>
      $fontSize ? $fontSize : "var(--font-size-base)"};
    border: 1px solid var(--tertiary-color);
    border-radius: 8px;
    background: var(--tertiary-color);
    color: var(--white-color);
    box-shadow: var(--box-shadow3);
  }
  .disactive-button {
    min-height: ${({ $height }) => ($height ? $height : "50px")};
    font-size: ${({ $fontSize }) =>
      $fontSize ? $fontSize : "var(--font-size-base)"};
    border: 1px solid var(--tertiary-color);
    border-radius: 8px;
    background: var(--white-color);
    color: var(--tertiary-color);
    box-shadow: var(--box-shadow3);
  }
`;
